import { render, staticRenderFns } from "./AstaPlan.vue?vue&type=template&id=474c9a18&scoped=true&"
import script from "./AstaPlan.vue?vue&type=script&lang=js&"
export * from "./AstaPlan.vue?vue&type=script&lang=js&"
import style0 from "./AstaPlan.vue?vue&type=style&index=0&id=474c9a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474c9a18",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('474c9a18')) {
      api.createRecord('474c9a18', component.options)
    } else {
      api.reload('474c9a18', component.options)
    }
    module.hot.accept("./AstaPlan.vue?vue&type=template&id=474c9a18&scoped=true&", function () {
      api.rerender('474c9a18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AstaPlan.vue"
export default component.exports